<template>
    <div class="row">
        <div class="col-lg-12 mb-4">
            <div class="box">
                <div class="box-offset">
                    <ValidationObserver ref="form" class="form ">
                        <div
                            v-for="(todo, index) in formArray" :key="index"
                        >
                            <ToDoForm
                                :todo.sync="todo"
                                :isMain="index === 0"
                                :index="index"
                            ></ToDoForm>

                        </div>
                        <div class="text-right mb-5">
                            <a href="javascript:void(0)"
                               class="back-link"
                               @click="addNewForm(false)"
                               v-if="!existSecondToDo"
                            >+ Add follow up task</a>
                        </div>
                        <div class="text-right mb-5">
                            <a href="javascript:void(0)"
                               class="back-link"
                               @click="removeSecondaryToDo"
                               v-if="existSecondToDo"
                            >Remove follow up task</a>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="btns-wrap">
                                    <button
                                        class="btn btn--outline-primary w-100 w-sm-auto"
                                        @click="backToPreviousPage"
                                    >Cancel</button>
                                    <button
                                        class="btn btn--secondary w-100 w-sm-auto"
                                        @click="save"
                                    >Save
                                    </button>
                                </div>
                            </div>
                        </div>
                    </ValidationObserver>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import ToDoService from "./services/ToDoService";
import ToDoForm from "./ToDoForm.vue";
import ModalHandler from "../../../../../resources/js/mixins/ModalHandler";

export default {
    name: 'NewToDo',
    components: {ToDoForm},
    mixins: [ModalHandler],
    data() {
        return {
            formArray: [],
        }
    },
    methods: {
        async save() {
            const valid = await this.$refs.form.validate();

            if (!valid) {
                this.$showValidationErrorMessage();
                return;
            }
            this.$showLoadingMessage()
            try {
                await ToDoService.addNewTodo(this.formArray)
                this.$showSuccessMessage('New ToDo was added!');
                setTimeout(() => {
                    window.location.href = '/master-admin/to-do'
                }, 1000)
            } catch (e) {
                this.$showErrorMessage();
            }
        },
        removeSecondaryToDo() {
            this.formArray.splice(1, 1);
        },
        addNewForm(isMain) {
            this.formArray.push({
                title: null,
                assigned_to: null,
                start_date: null,
                dead_line: null,
                description: null,
                priority: null,
                is_main: isMain,
                client: null,
            });
        },
    },
    mounted() {
        if (this.formArray.length === 0) {
            this.addNewForm(true);
        }
    },
    computed: {
        existSecondToDo() {
            return this.formArray.length > 1;
        }
    }
}

</script>

<style scoped>

</style>
